class Conflict extends Error {
    constructor(message = 'Conflict. The request could not be completed due to a conflict with the current state of the resource.') {
      super(message)
      this.name = this.constructor.name
      this.status = 409
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = Conflict
